import { useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { ICalculation } from "../../models/calculation";

const capitalize = (s: string) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
};

interface IProps {
    //verticesLimits: IVerticesFiltering[];
    calculation: ICalculation
}

export const VerticesLimitsDisplay = ({ calculation }: IProps) => {
    const [activeHour, setActiveHour] = useState(-1);
    const handleAccordionClick = (index: number) => {
        activeHour === index ? setActiveHour(-1) : setActiveHour(index);
    };
    const verticesLimits = calculation.verticesLimits;
    return (
        <Accordion className="np-shifts-accordion">
            {verticesLimits?.map(vertexLimits => (
                <div key={vertexLimits.hour}>
                    <Accordion.Title
                        active={activeHour === vertexLimits.hour}
                        index={0}
                        onClick={() => handleAccordionClick(vertexLimits.hour)}
                    >
                        <Icon name="dropdown" />
                        {//vertexLimits.hour.toString().padStart(2, "0") + ":30"
                            calculation.activeTimestamps?.find((element) => element.key === vertexLimits.hour)?.text
                        }
                    </Accordion.Title>
                    <Accordion.Content active={activeHour === vertexLimits.hour}>
                        {Object.entries(vertexLimits.values).map(elem => (
                            <p key={elem[0]}>
                                <label>{elem[0].toUpperCase()}:&nbsp;</label>
                                {Object.entries(elem[1]).map(np => (
                                    <div key={np[0]} className="np-shift-element">
                                        <p>
                                            <label>
                                                {capitalize(np[0])}
                                                :&nbsp;
                                            </label>
                                            {np[1]}
                                        </p>
                                    </div>
                                ))}
                            </p>
                        ))}
                    </Accordion.Content>
                </div>
            ))}
        </Accordion>
    );
};
